/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerEmailSettings.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Email Settings
 *  
 *  Author:     Norman J. Nolasco [ Archetact ]
 *
 *  Created:    Saturday, August 27, 2022 - 05:58:16 PM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      08/27/2022  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2022 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    EMAILSETTING_LIST_CONTAINER_LOADED,
    EMAILSETTING_LIST_CONTAINER_UNLOADED,
    EMAILSETTING_LIST_TABLE_LOADED,
    EMAILSETTING_LIST_TABLE_UNLOADED,

    EMAILSETTING_SELECT_ROW,
    EMAILSETTING_ADD,
    EMAILSETTING_EDIT,
    EMAILSETTING_DELETE,
    EMAILSETTING_OPEN_WARNING,
    EMAILSETTING_CLOSE_WARNING,
    EMAILSETTING_DELETE_DISABLE,

    EMAILSETTING_EDIT_CONTAINER_LOADED,
    EMAILSETTING_EDIT_CONTAINER_UNLOADED,
    EMAILSETTING_EDIT_FORM_LOADED,
    EMAILSETTING_EDIT_FORM_UNLOADED,
    EMAILSETTING_EDIT_DATA_LOAD,
    EMAILSETTING_EDIT_CONTAINER_SUBMIT,
    EMAILSETTING_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeEmailSettings';

const defaultState = {
    refreshList: false,
    danger: false,
    emailsettingid: 0,
    name: '',
    description: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case EMAILSETTING_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                emailsettings: action.payload[0] ? action.payload[0].records : null
            }
        case EMAILSETTING_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case EMAILSETTING_SELECT_ROW:
            return {
                ...state,
                emailsettingid: action.id
            }
        case EMAILSETTING_ADD:
            return {
                ...state
            }
        case EMAILSETTING_EDIT:
            return {
                ...state,
                emailsettingid: action.id
            }
        case EMAILSETTING_DELETE:
            return {
                ...state,
                emailsettingid: null
            }
        case EMAILSETTING_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case EMAILSETTING_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case EMAILSETTING_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case EMAILSETTING_EDIT_CONTAINER_LOADED:
        case EMAILSETTING_EDIT_DATA_LOAD:
            return {
                ...state,
                emailsettingid: action.payload[0] ? action.payload[0].emailsettingid : 0,
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case EMAILSETTING_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case EMAILSETTING_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case EMAILSETTING_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case EMAILSETTING_LIST_CONTAINER_UNLOADED:
        case EMAILSETTING_LIST_TABLE_UNLOADED:
        case EMAILSETTING_EDIT_CONTAINER_UNLOADED:
        case EMAILSETTING_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};
